import { render, staticRenderFns } from "./FormBuildersList.vue?vue&type=template&id=c173afb2&scoped=true"
import script from "./FormBuildersList.vue?vue&type=script&lang=js"
export * from "./FormBuildersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c173afb2",
  null
  
)

export default component.exports